import type {
    QuippyBuildingSession,
    QuippyMessage,
    QuippyThread,
} from '../models';

export function retryAssistantMessageInSession(
    session: QuippyBuildingSession,
    chatId: string,
    messageId: string,
    update: Partial<
        Pick<
            QuippyMessage,
            | 'content'
            | 'status'
            | 'sources'
            | 'retryInput'
            | 'retrySelectedFileId'
            | 'packAction'
            | 'documentOptions'
        >
    >
): QuippyBuildingSession {
    return updateThreadInSession(session, chatId, (thread) => {
        const messageIndex = thread.messages.findIndex(
            (message) => message.id === messageId
        );
        const message = thread.messages[messageIndex];
        if (message?.role !== 'assistant') return thread;

        const updatedMessage: QuippyMessage = {
            ...message,
            ...update,
            sources: update.sources ?? message.sources,
            packAction: update.packAction,
            documentOptions: update.documentOptions ?? message.documentOptions,
        };

        return {
            ...thread,
            messages: [
                ...thread.messages.slice(0, messageIndex),
                updatedMessage,
            ],
        };
    });
}

export function restoreThreadInSession(
    session: QuippyBuildingSession,
    chatId: string,
    restoredThread: QuippyThread
): QuippyBuildingSession {
    return updateThreadInSession(session, chatId, () => restoredThread);
}

function updateThreadInSession(
    session: QuippyBuildingSession,
    chatId: string,
    updater: (thread: QuippyThread) => QuippyThread
): QuippyBuildingSession {
    return {
        ...session,
        threads: session.threads.map((thread) =>
            thread.id === chatId ? updater(thread) : thread
        ),
    };
}
